'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$uibModal', function ($modal) {

    return {
        show: show,
    };

    function show(attachments) {
        return $modal.open({
            template: require('../view/file-modal-read.html'),
            controller: 'FileModalReadController',
            size: 'md',
            backdrop: false,
            resolve: {
                items: function () {
                    return attachments;
                }
            }
        });
    }

}];